module.exports = __webpack_public_path__ + "static/media/badge-woorank.e7cffd2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/badge-woorank.png
// module id = 303
// module chunks = 0